import * as api from '../api';
export const SET_TEAM = 'team/SET_TEAM';
export const getTeam = () => async dispatch => {
  const {
    team,
    subscription
  } = await api.getTeam();
  dispatch({
    type: SET_TEAM,
    payload: {
      team,
      subscription
    }
  });
};
export const removeMemberFromTeam = (teamId, userId) => async dispatch => {
  const result = await api.removeMemberFromTeam(teamId, userId);
  const {
    team
  } = result;
  if (team) {
    dispatch({
      type: SET_TEAM,
      payload: {
        team
      }
    });
  }
  return result;
};
export const setTeamManager = (teamId, userId, enabled) => async dispatch => {
  const result = await api.setTeamManager(teamId, userId, enabled);
  if (result.team) {
    dispatch({
      type: SET_TEAM,
      payload: {
        team: result.team
      }
    });
  }
  return result;
};
export const addMemberToTeam = (teamId, userId) => async dispatch => {
  const {
    team,
    subscription,
    error
  } = await api.addMemberToTeam(teamId, userId);
  if (team || error) {
    dispatch({
      type: SET_TEAM,
      payload: {
        team,
        subscription,
        error
      }
    });
  }
};
export const setTeamOnboarding = (teamId, onboarding) => async dispatch => {
  const result = await api.postTeamOnboarding(teamId, onboarding);
  const {
    team
  } = result;
  if (team) {
    dispatch({
      type: SET_TEAM,
      payload: {
        team
      }
    });
  }
  return result;
};